<template>
	<div class="receipts-control d-print-none">
		<div :class="privileges.includes(sec) ? 'upload-btn':'un-upload-btn'" @click="onCreateClaim()">
			<v-icon left mid color="#FFFFFF">mdi-plus</v-icon>
			<span v-if="$vuetify.breakpoint.lgAndDown">Create</span>
			<span v-else>Create Claim</span>
		</div>
		<div :class="control && itemNumberSubmit > 0 && privileges.includes(sec)? 'create-btn' : 'un-create-btn'" class="default-btn ml-3" @click="onSubmit()">
			<CircleIcon v-if="!$vuetify.breakpoint.mdAndDown && !submitLoading" width="20" height="20" color="#FFFFFF" class="mr-2"/>
			<v-progress-circular v-if="!$vuetify.breakpoint.mdAndDown && submitLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>
			<span v-if="$vuetify.breakpoint.mdAndDown">Submit</span>
			<span v-else>
				Submit&nbsp;Claims&nbsp;<span v-if="itemNumberSubmit > 0">({{ itemNumberSubmit }})</span>
			</span>
		</div>
		<div 
			v-if="!$vuetify.breakpoint.mdAndDown"
			class="default-btn ml-3"
			:class="control ? 'print-btn': 'un-print-btn'"
			@click="onPrint()">
			<PrinterIcon v-if="!printDialog" width="20" height="20" class="mr-2" :color="control? '#2196F3':'rgba(25, 42, 62, 0.3)'"/>
			<v-progress-circular v-if="printDialog" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Print&nbsp;Claims&nbsp;<span v-if="itemNumber > 0">({{ itemNumber }})</span>
		</div>
		<div :class="control && itemNumberDelete > 0 && privileges.includes(sec) ? 'delete-btn' : 'un-delete-btn'"  class="default-btn ml-3" @click="onDelete()">
			<DeleteIcon v-if="!$vuetify.breakpoint.mdAndDown" width="20" height="20" class="mr-1 mt-1" :color="control && itemNumberDelete > 0 && privileges.includes(sec) ? 'rgba(25, 42, 62, 0.6)':'rgba(25, 42, 62, 0.3)'" />
			<span v-if="$vuetify.breakpoint.mdAndDown">Delete</span>
			<span v-else>
				Delete&nbsp;Claims&nbsp;<span v-if="itemNumberDelete > 0 && privileges.includes(sec)">({{ itemNumberDelete }})</span>
			</span>
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" :class="control && (itemNumberRecover > 0) && privileges.includes(sec)? 'delete-btn' : 'un-delete-btn'" class="default-btn ml-3" @click="onRecover()">
			<v-icon v-if="!visibleRecover" :color="control && itemNumberRecover > 0 && privileges.includes(sec) ? 'rgba(25, 42, 62, 0.6)':'rgba(25, 42, 62, 0.3)'"  class="mr-2">mdi-backup-restore</v-icon>
			<v-progress-circular v-if="visibleRecover" class="mr-1" :width="2" :size="16" :value="20" :color="`rgba(25, 42, 62, 0.6)`" indeterminate></v-progress-circular>
			<span>
				Recover&nbsp;<span v-if="itemNumberRecover > 0">({{ itemNumberRecover }})</span>
			</span>
		</div>
	</div>
</template>
<script>
import DeleteIcon from "@/components/icons/delete_outline";
import CircleIcon from "@/components/icons/submit_circle_outline";
import PrinterIcon from "@/components/icons/printer";

const SEC = 'Sec';

export default {
	name: 'ClaimButton',
	props: {
		control: {
			type: Boolean,
			default: false
		},
		itemNumber: {
			type: Number,
			default: 0
		},
		itemNumberSubmit: {
			type: Number,
			default: 0
		},
		itemNumberDelete: {
			type: Number,
			default: 0
		},
		itemNumberRecover: {
			type: Number,
			default: 0
		},
		privileges: {
			type: Array,
			default: () => []
		},
		submitLoading: {
			type: Boolean,
			default: false
		},
		printDialog: {
			type: Boolean,
			default: false
		},
		visibleRecover: {
			type: Boolean,
			default: false
		}
	},
	components: {
		DeleteIcon,
		CircleIcon,
		PrinterIcon
	},
	data() {
		this.sec = SEC;
		return {}
	},
	methods: {
		onCreateClaim() {
			if (this.privileges.includes(this.sec)) {
				this.$emit('create-claim');
			}
		},
		onDelete() {
			if (this.control && this.itemNumberDelete > 0) {
				this.$emit('del-claims');
			}
		},
		onSubmit() {
			if (this.control && this.itemNumberSubmit > 0) {
				this.$emit('submit');
			}
		},
		onPrint() {
			if (this.control && this.itemNumber > 0) {
				this.$emit('print');
			}
		},
		onRecover() {
			if (this.control && this.itemNumberRecover > 0) {
				this.$emit('recover');
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.receipts-control {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
}
.default-btn {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
	padding: 0 14px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	border-radius: 4px; 
}
.delete-btn {
  color: rgba(8, 14, 20, 0.7);
	border: 1px solid rgba(25, 42, 62, 0.7);
	&:hover {
		cursor: pointer;
	}
}
.un-delete-btn {
	color: rgba(8, 14, 20, 0.3);
	border: 1px solid rgba(25, 42, 62, 0.3);
}
.create-btn {
  color: #FFFFFF;
	background: #00AAFD;
	&:hover {
		cursor: pointer;
	}
}
.un-create-btn {
  color: #FFFFFF;
	background: rgba(25, 42, 62, 0.3);
}
.print-btn {
  color: #2196F3;
  border: 1px solid #2196F3;
	&:hover {
		cursor: pointer;
	}
}
.un-print-btn {
	color: rgba(8, 14, 20, 0.3);
	border: 1px solid rgba(25, 42, 62, 0.3);
}
.upload-btn {
  height: 36px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 14px;
  background: #00AAFD;
  border-radius: 4px;
  color: #FFFFFF;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  &:hover {
    cursor: pointer;
  }
}
.un-upload-btn {
  height: 36px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 14px;
  background: rgba(25, 42, 62, 0.3);
  border-radius: 4px;
  color: #FFFFFF;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
}
</style>